import starFirstPart from 'assets/img/star-first-part.png';
import starSecondPart from 'assets/img/star-second-part.png';
import smallStarFirstPart from 'assets/img/small-star-1.png';
import smallStarSecondPart from 'assets/img/small-star-2.png';

import './overlayStarAnimation.styl';

import classNames from 'classnames';

export interface IOverlayStarAnimationProps {
    className?: string;
    small?: boolean;
}

export const OverlayStarAnimation = ({ className, small }: IOverlayStarAnimationProps) => {
    return (
        <div className={classNames(['box', className], { ['box-small']: small })}>
            <img src={small ? smallStarFirstPart : starFirstPart} className="star star-first" />
            <img src={small ? smallStarSecondPart : starSecondPart} className="star star-second" />
        </div>
    );
};
